import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TelegramService } from '../telegram';
import { environment } from '../../../src/environment/environment';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const telegram = inject(TelegramService);
  const initData = telegram.initData || environment.INIT_DATA;

  if (!telegram.initData) {
    // // alert('No TG Init Data');
  }

  // alert('InitData ' + initData.length);

  const request = req.url.includes('auth') || req.headers.has('Authorization')
    ? req.clone()
    : req.clone({
      setHeaders: {
        Authorization: initData,
      },
    });

  return next(request).pipe(
    catchError(error => {
      // Показуємо простий алерт
      // alert(`❌ HTTP Error ${error?.status || error?.error?.status}: ${error?.detail || error?.error?.detail || 'Unknown error'}`);

      // Лог для DevTools
      console.error('[HTTP ERROR]', {
        url: req.url,
        method: req.method,
        status: error.status,
        message: error.message,
        error,
      });

      // Прокидуємо далі, якщо треба — або замінити на throwError(() => new Error(...))
      return throwError(() => error);
    })
  );
};
